var map = {
	"./br/PT/S1/fjbg6.png": 36897,
	"./fjbg6.png": 97414,
	"./in/EN/S1/fjbg6.png": 64805,
	"./ph/EN/S1/fjbg6.png": 47086,
	"./ph/EN/S2/fjbg6.png": 92360,
	"./vn/VI/S1/fjbg6.png": 34402
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80793;